import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export type PreparationDays = 0 | 1 | 2;

export const PREPARATION_DAYS: PreparationDays[] = [0, 1, 2];

export default class BookingRestrictionModel extends Model {
  @attr('string') channel!: string;

  @attr('number') airbnbMaximumLengthOfStay!: number;
  @attr('number') airbnbMinimumAdvanceNotice!: number;
  @attr('boolean') airbnbRequestsAllowed!: boolean;

  @attr('boolean') closedForArrivalSunday!: boolean;
  @attr('boolean') closedForArrivalMonday!: boolean;
  @attr('boolean') closedForArrivalTuesday!: boolean;
  @attr('boolean') closedForArrivalWednesday!: boolean;
  @attr('boolean') closedForArrivalThursday!: boolean;
  @attr('boolean') closedForArrivalFriday!: boolean;
  @attr('boolean') closedForArrivalSaturday!: boolean;

  @attr('boolean') closedForDepartureSunday!: boolean;
  @attr('boolean') closedForDepartureMonday!: boolean;
  @attr('boolean') closedForDepartureTuesday!: boolean;
  @attr('boolean') closedForDepartureWednesday!: boolean;
  @attr('boolean') closedForDepartureThursday!: boolean;
  @attr('boolean') closedForDepartureFriday!: boolean;
  @attr('boolean') closedForDepartureSaturday!: boolean;

  @attr('number') homeawayMinimumAdvanceNotice!: number;

  @attr('number') maximumLengthOfStay!: number;
  @attr('number') minimumAdvanceNotice!: number;
  @attr('number') minimumLengthOfStay!: number;

  @attr('number', { defaultValue: 1 }) multiUnitCount!: number;
  @attr('number', { defaultValue: 0 }) preparationDays!: PreparationDays;

  @attr('boolean', { defaultValue: false }) gapNightsEnabled!: boolean;
  @attr('number') gapNightsMinimumLengthOfStay!: number;
  @attr('number') gapNightsDaysBeforeCheckInStart!: number;
  @attr('number') gapNightsDaysBeforeCheckInEnd!: number;

  @belongsTo('property', { inverse: 'bookingRestriction', async: false })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'booking-restriction': BookingRestrictionModel;
  }
}
